module.exports = __webpack_public_path__ + "static/VSKeys-be5ccc65b7f749eb962ad000c4aed2bd.gif";